import * as tooltips from "./tooltips";
import GeoJSONPointsCollection from "../../../../components/maps/GeoJSONMap/GeoJSONPointsCollection";
import React from "react";
import * as markers from "./markers";


const Models23Layer = ({webgis}) => {
    const {featuresState} = webgis;
    const {
        model23GeoJSON,
        model23SelectedState,
        contrastColorsHash
    } = featuresState;
    const defaultColor = "#1e88e5"
    const textColor = contrastColorsHash[defaultColor] ?? '#ffffff';

    const models23MarkerIconFn = (feature) => {
        return markers.model23Marker({feature, value:null, colorCode: defaultColor, textColor});
    }

    const models23ClusterIconFn = (cluster) => {
        return markers.model23Cluster({cluster, colorCode: defaultColor, value: null, textColor})
    }

    const models23ClusterGroupKey = `models23ClusterGroup-${model23GeoJSON?.features?.length}-${featuresState.geoModel23Query?.dataUpdatedAt}`;

    return <GeoJSONPointsCollection featureCollection={model23GeoJSON}
                                    cluster
                                    getSelectedFeatures={model23SelectedState.getSelectedFeatures}
                                    onFeatureClick={webgis.handleModel23Click}
                                    renderFeatureTooltip={tooltips.renderModel23Tooltip}
                                    markerIconFn={models23MarkerIconFn}
                                    clusterIconFn={models23ClusterIconFn}
                                    clusterGroupProps={{key: models23ClusterGroupKey}}
    />
}

export default Models23Layer;